import type { AppState, AppAction } from '@/types';
import { CookieManager } from '@/utils/CookieManager';
import { actionTypes } from '@/store/takeQuizActions'


export const appReducer = (state: AppState, action: AppAction): AppState => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isLoading: false,
        error: null
      };

    case 'LOGIN_FAILURE':
      return {
        ...state,
        user: null,
        token: null,
        isLoading: false,
        error: action.payload
      };

    case 'QUIZ_REPORTS_FILTER':
      return {
        ...state,
        quizReportsFilter: {
          ...state.quizReportsFilter,
          ...action.payload
        }
      };


    case 'LOGOUT': {
      // Preserve is_first_time before clearing
      const isFirstTime = localStorage.getItem('is_first_time');

      // Clear ALL localStorage items
      localStorage.clear();

      // Restore the preserved field
      if (isFirstTime !== null) {
        localStorage.setItem('is_first_time', isFirstTime);
      }

      // Clear sessionStorage
      sessionStorage.clear();

      // Clear all cookies
      CookieManager.remove('authToken');
      CookieManager.remove('token');
      CookieManager.remove('userData');

      return {
        ...state,
        user: null,
        token: null,
        error: null,
        navbarActiveTab: '',
        firstQuestionId: 0,
        currentQuestionId: null,
        isFromCreateQuiz: false,
        isExplanationOn: false,
        imagePath: '',
        isQuestionPopupOpen: false,
        quizTitle: '',
        errorNotification: null
      };
    }

    case 'SET_NAVBAR_ACTIVE_TAB':
      return {
        ...state,
        navbarActiveTab: action.payload
      };

    case 'SET_IS_FROM_CREATE_QUIZ':
      return {
        ...state,
        isFromCreateQuiz: action.payload
      };

    case 'SET_QUIZ_REPORTS_FILTER':
      return {
        ...state,
        quizReportsFilter: action.payload
      };

    case 'QUIZ_QUESTION_ID':
      return {
        ...state,
        currentQuestionId: typeof action.payload === 'number' ? action.payload : null,
        firstQuestionId: typeof action.payload === 'number' ? action.payload : state.firstQuestionId
      };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };

    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };

    case 'SET_QUIZ_QUESTIONS':
      return {
        ...state,
        quizQuestions: action.payload
      };

    case 'SET_IS_EXPLANATION_ON':
      return {
        ...state,
        isExplanationOn: action.payload
      };

    case 'SET_IMAGE_PATH':
      return {
        ...state,
        imagePath: action.payload
      };

    case 'SET_FIRST_QUESTION_ID':
      return {
        ...state,
        firstQuestionId: action.payload
      };

    case 'SET_IS_QUESTION_POPUP_OPEN':
      return {
        ...state,
        isQuestionPopupOpen: action.payload
      };

    case actionTypes.SET_QUIZ_TITLE:
      return {
        ...state,
        quizTitle: action.payload
      };

    case 'SET_ERROR_NOTIFICATION':
      return {
        ...state,
        errorNotification: action.payload
      };
    case 'SET_SCORING_SETTINGS':
      return {
        ...state,
        quizScoringSettings: action.payload,
      }
    case actionTypes.UPDATE_BROWSER_SETTINGS:
      return {
        ...state,
        quizBrowserSettings: {
          ...(state.quizBrowserSettings || {}),
          ...action.payload,
        },
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null
      };
    case actionTypes.SET_QUIZ_PROGRESS:
      return {
        ...state,
        quizProgress: state.quizProgress + 1,
      };

    case actionTypes.RESET_QUIZ_PROGRESS:
      return {
        ...state,
        quizProgress: 0,
      };

    case actionTypes.SET_QUIZ_PROGRESS_VALUE:
      return {
        ...state,
        quizProgress: Number(action.payload) || 0,
      };

    case actionTypes.SET_QUIZ_GENERAL_SETTINGS:
      return {
        ...state,
  quizGeneralSettings: action.payload as import('@/types/takeQuiz').QuizGeneralSettings,
      };

    case actionTypes.SET_QUIZ_BROWSER_SETTINGS:
      return {
        ...state,
        quizBrowserSettings: action.payload,
      };

    case actionTypes.SET_TAKE_QUIZ_QUESTION:
      return {
        ...state,
  takeQuizQuestion: action.payload as import('@/types/takeQuiz').TakeQuizQuestion,
      };

    case actionTypes.SET_QUIZ_RESULT:
      return {
        ...state,
        quizResult: action.payload,
      };

    case actionTypes.SET_COMPLETE_QUESTION:
      return {
        ...state,
        completeQuestion: action.payload,
      };

    case actionTypes.SET_IS_TIMEOUT_FORCE_SUBMIT:
      return {
        ...state,
  // Use the correct state property name expected by selectors/components
  isTimeOutForceSubmit: action.payload,
      };

    case actionTypes.SET_IS_SECURITY_SUBMIT:
      return {
        ...state,
        isSecuritySubmit: action.payload,
      };

    case actionTypes.SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actionTypes.SET_CURRENT_QUIZ_ID:
      return {
        ...state,
        currentQuizResultId: action.payload,
      };
    case actionTypes.UPDATE_USER_OFFLINE_COUNT:
      return {
        ...state,
        userOfflineCount: state.userOfflineCount + 1,
      };
    case actionTypes.SET_IS_USER_OFFLINE:
      return {
        ...state,
        isUserOffline: action.payload,
      };
    case 'SET_VIDEO_MODAL_OPEN':
      return {
        ...state,
        isVideoModalOpen: action.payload,
      };
    default:
      return state;
  }
};